import moment from 'moment'
import i18next from 'i18next'

import { removeSymbolsFromPhone } from 'helpers/parsePhone'
import { parseHTMLString } from 'helpers/parseHTMLString'
import { formatByISO } from 'app/constants/phoneCountryCodes'

export const required =
  (message = 'Required Field') =>
  value =>
    value ? undefined : i18next.t(message)

export const maxLength = max => value =>
  value && value.length > max ? i18next.t('Max characters allowed', { max }) : undefined

export const minLength = min => value =>
  value && value.length < min ? i18next.t('Min characters allowed', { min }) : undefined

export const phoneMinLength = () => (value, row) => {
  const phone = value && removeSymbolsFromPhone(value)
  const phoneISO = row.get('phoneISO')
  return phone && phone.length < formatByISO[phoneISO].min && phoneISO
    ? i18next.t('Min characters allowed', { min: formatByISO[phoneISO].min })
    : undefined
}

export const phoneMaxLength = () => (value, row) => {
  const phone = value && removeSymbolsFromPhone(value)
  const phoneISO = row.get('phoneISO')
  return phone && phone.length > formatByISO[phoneISO].max
    ? i18next.t('Max characters allowed', { max: formatByISO[phoneISO].max })
    : undefined
}

export const number = value => (value && isNaN(Number(value)) ? i18next.t('Only numbers allowed') : undefined)

export const minValue = min => value => value && value < min ? i18next.t('Min', { min }) : undefined

export const minValueOrZero = min => value => {
  if (value && parseFloat(value) === 0) {
    return undefined
  }
  if (value && value < min) {
    return i18next.t('common:Min or 0', { min })
  }
  return undefined
}

export const email = value =>
  value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value) ? i18next.t('Wrong Email') : undefined

export const phoneNumber = value =>
  value && !/^(0|[1-9][0-9]{9})$/i.test(value) ? i18next.t('Wrong telephone number') : undefined

export const dateRangeRequired =
  (message = 'is Required') =>
  value => {
    if (!value) {
      return { startDate: i18next.t('Start Date', { message }) }
    }
    if (value.get && !value.get('startDate')) {
      return {
        startDate: i18next.t('Start Date', { message }),
      }
    }
    if (value.get && !value.get('endDate')) {
      return { endDate: i18next.t('Finish Date', { message }) }
    }
    return undefined
  }

export const isDaysIncludesToday =
  (message = 'Please select days that includes today') =>
  days => {
    const res = days && !days.some(day => moment().isSame(day.get('startDate'), 'day'))
    if (res) {
      return i18next.t(message)
    }
    return undefined
  }

export const emptyArray =
  (message = 'Select at least one element') =>
  workWeek => {
    if (workWeek && workWeek.size === 0) {
      return i18next.t(message)
    }
    return undefined
  }

export const maxLengthWithHTML = max => value => {
  return value && parseHTMLString(value).length > max ? i18next.t('Max characters allowed', { max }) : undefined
}
